import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface UpdateTankLevelWidgetSettingsDto {
  name: string;
  selectedSiteId: string | undefined;
  selectedTankIds: string[] | undefined;
}

const useUpdateTankLevelWidgetSettings = (widgetId: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  return useUserRequest<UpdateTankLevelWidgetSettingsDto>({
    path: `/api/businesses/${business.id}/tankLevelWidgetSettings/${widgetId}`,
    method: HttpMethod.PUT,
  }, options);
}

export default useUpdateTankLevelWidgetSettings;
